import { createElement } from "../21946.js";

var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var more_SvgMore = function SvgMore(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/createElement("g", {
    clipPath: "url(#more_svg__a)"
  }, /*#__PURE__*/createElement("mask", {
    id: "more_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), /*#__PURE__*/createElement("g", {
    mask: "url(#more_svg__b)"
  }, /*#__PURE__*/createElement("mask", {
    id: "more_svg__c",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/createElement("g", {
    mask: "url(#more_svg__c)"
  }, /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 6.5C1.17 6.5.5 7.17.5 8S1.17 9.5 2 9.5 3.5 8.83 3.5 8 2.83 6.5 2 6.5m6 0c-.83 0-1.5.67-1.5 1.5S7.17 9.5 8 9.5 9.5 8.83 9.5 8 8.83 6.5 8 6.5M12.5 8c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5",
    clipRule: "evenodd"
  }))))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "more_svg__a"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
/* export default */ const more = (more_SvgMore);
export default more;
